import Icon from '../../shared/components/Icons';
import { fmtDay } from '../../shared/data/common';
import { durationLabel, timeLabel } from './searchModel';

/** Bus booking summary used on review, confirmation and booking details pages. */
export default function BusSummary({ summary: s }) {
  return (
    <div className="sum">
      <div className="sum-media">
        <span className="transfer-icon sm"><Icon name="bus" size={26} strokeWidth={1.5} /></span>
        <div>
          <span className="tag">{s.from} → {s.to}</span>
          <h3>{s.operator}</h3>
          {s.busType && <span className="muted small">{s.busType}</span>}
        </div>
      </div>
      <div className="route-box">
        <div><span className="dot dot-start" /><div><span className="muted small">Boarding · {s.boarding.time ? `${fmtDay(s.boarding.time.slice(0, 10))}, ${timeLabel(s.boarding.time)}` : fmtDay(s.date)}</span><b>{s.boarding.name}</b>{s.boarding.address && <span className="muted small">{s.boarding.address}</span>}</div></div>
        <div><span className="dot dot-end" /><div><span className="muted small">Dropping{s.dropping?.time ? ` · ${fmtDay(s.dropping.time.slice(0, 10))}, ${timeLabel(s.dropping.time)}` : ''}</span><b>{s.dropping?.name || s.to}</b>{s.dropping?.address && <span className="muted small">{s.dropping.address}</span>}</div></div>
      </div>
      <div className="kv-grid">
        <div><span className="muted small">Departure</span><b>{fmtDay(s.date)}, {timeLabel(s.departure)}</b></div>
        {s.duration > 0 && <div><span className="muted small">Journey time</span><b>{durationLabel(s.duration)}</b></div>}
        <div><span className="muted small">Seat{s.seats.length > 1 ? 's' : ''}</span><b>{s.seats.join(', ')}</b></div>
      </div>
      <div className="sum-foot">
        {s.refundNote && <span className="text-primary"><Icon name="check" size={14} /> {s.refundNote}</span>}
        {s.idProofRequired && <span><Icon name="file" size={14} /> Carry the ID proof given at booking</span>}
        {s.mTicketAllowed && <span><Icon name="mobile" size={14} /> m-Ticket accepted</span>}
      </div>
    </div>
  );
}
